import { createEntityFilterChip } from 'components/filters/createEntityFilterChip';
import { outletOrServiceCategoryFieldProps } from './OutletOrServiceCategoryField';

export const OutletOrServiceCategoryFilterChip = createEntityFilterChip('supplier/outlet_or_service_category/', {
  ...outletOrServiceCategoryFieldProps,
  suggestion: true,
});
